/**
 * The zone every staging host sits under. Production serves the bare
 * `dmre.com` hosts, so only this suffix identifies staging.
 */
export const STAGING_ZONE = 'staging.dmre.com';

/**
 * Tells whether a Host header or a `location.host` names a staging host.
 * The value may carry a port and any case.
 */
export function isStagingHost(host) {
  if (typeof host !== 'string') {
    return false;
  }
  const hostname = host.trim().toLowerCase().split(':')[0].replace(/\.$/, '');
  return hostname === STAGING_ZONE || hostname.endsWith(`.${STAGING_ZONE}`);
}
